/**
 * Auth endpoints
 */
export const authEndpoints = {
  me: () => '/api/auth/me',
  login: () => '/api/auth/login',
  logout: () => '/api/auth/logout'
}
